import { Components, svgIconClasses, Theme } from '@mui/material';

import {
  AlertError,
  AlertInfo,
  AlertSuccess,
  AlertWarning,
  Close,
} from '../../../icons';

export const getMuiAlert = (theme: Theme): Components['MuiAlert'] => ({
  defaultProps: {
    iconMapping: {
      info: <AlertInfo />,
      warning: <AlertWarning />,
      success: <AlertSuccess />,
      error: <AlertError />,
    },
    components: {
      CloseIcon: Close,
    },
  },
  styleOverrides: {
    root: {
      padding: theme.spacing(2.5, 3),
      borderRadius: theme.shape.borderRadius,
      width: 308,
    },
    icon: {
      [`& > .${svgIconClasses.root}`]: {
        color: `var(--type-color, ${theme.palette.text.primary})`,
      },
      marginRight: theme.spacing(2),
      padding: 0,
    },
    standardError: {
      background: theme.palette.error.light,
      '--type-color': theme.palette.error.main,
    },
    standardSuccess: {
      background: theme.palette.success.light,
      '--type-color': theme.palette.success.main,
    },
    standardInfo: {
      background: theme.palette.indigo.light,
      '--type-color': theme.palette.link.main,
    },
    standardWarning: {
      background: theme.palette.warning.light,
      '--type-color': theme.palette.warning.main,
    },
    message: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '140%',
      width: '100%',
      color: theme.palette.grey[900],
      padding: 0,
      marginTop: 3,
      overflow: 'visible',
    },
  },
});
